





























import CategoryChooserSectionItem from '~/components/car/category/chooser/CategoryChooserSectionItem.vue'
import { CategoryId } from '~/models/category/types'
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  components: { CategoryChooserSectionItem },
  props: {
    type: {
      type: String,
      default: 'classifieds'
    },
    children: {
      type: Array,
      required: true,
      default() {
        return []
      }
    },
    label: {
      type: String,
      required: true
    }
  },
  methods: {
    isNuxtUrl(child: any) {
      const {
        category: { id, parentId }
      } = child
      return (
        id !== CategoryId.CARS &&
        parentId !== CategoryId.CARS &&
        id !== CategoryId.BIKES
      )
    }
  }
})
